import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardText,
  CardTitle,
  Col,
  Row,
} from "reactstrap";
import NibbleInput from "../../../components/Fields/NibbleInput";
import { getConditionsCatalog } from "../../../helpers/backend_helper";
import CardLoader from "../../../components/Common/CardLoader";
import * as _ from "lodash";

const Conditions = ({ selected = {}, validation, isReadOnly = false }) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);

    getConditionsCatalog()
      .then((resp) => {
        const conditions = resp.map((i) => ({
          ...i,
          works_on_start: false,
          works_on_finish: false,
        }));
        const conditionsByKey = _.keyBy(conditions, "name");
        const selectedByKey = _.keyBy(selected, "name");

        const newConditions = {
          ...conditionsByKey,
          ...selectedByKey,
        };

        validation.setFieldValue("conditions", newConditions);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  if (isLoading)
    return (
      <CardLoader title="Cargando condiciones del vehículo antes y despues" />
    );

  return (
    <Card className="my-4 installation">
      <CardHeader>
        <h5 className="m-0">Condiciones del Vehículo Antes y Después de la Instalación</h5>
      </CardHeader>
      <CardBody>
        <Row>
          <Col md={12}>
            <table className="w-100">
              <thead>
                <tr style={{ textAlign: "center" }}>
                  <th className="text-center" style={{ width: "25%" }}>
                    ¿Funciona al iniciar?
                  </th>
                  <th className="text-center" style={{ width: "50%" }}></th>
                  <th className="text-center" style={{ width: "25%" }}>
                    ¿Funciona al terminar?
                  </th>
                </tr>
              </thead>
              <tbody>
                {Object.values(validation.values.conditions).map(
                  ({ id, name }) => {
                    return (
                      <tr key={id}>
                        <td>
                          <NibbleInput
                            md={12}
                            fieldName={`conditions.${name}.works_on_start`}
                            fieldType="single-checkbox"
                            validation={validation}
                            readOnly={isReadOnly}
                          />
                        </td>
                        <td className="text-center">
                          <label>{name}</label>
                        </td>
                        <td>
                          <NibbleInput
                            md={12}
                            fieldName={`conditions.${name}.works_on_finish`}
                            fieldType="single-checkbox"
                            validation={validation}
                            readOnly={isReadOnly}
                          />
                        </td>
                      </tr>
                    );
                  }
                )}
              </tbody>
            </table>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default Conditions;
